var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber, Contract } from 'ethers';
import createMulticallPlugin from '../../../Fct/plugins/Multicall/generic/createMulticallPlugin';
import * as plugins from '../../../Fct/pluginsExport';
import { kiroboMulticallSimulateContracts } from '../KIROBO_MULTICALL_CSV/constants';
import erc20Abi from '../../../abis/erc20.json';
export var Erc20Airdrop = createMulticallPlugin({
    plugin: plugins.ERC20.actions.SimpleTransfer,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY',
    method: 'erc20Airdrop',
    name: 'erc20Airdrop',
    config: {
        params: [
            { key: 'to', multicallKey: 'token', isUnique: true },
            { key: 'methodParams.from', multicallKey: 'from', isUnique: true },
            { key: 'methodParams.amount', multicallKey: 'amount', isUnique: true },
            { key: 'methodParams.to', multicallKey: 'recipient' },
        ],
        tupleName: 'recipients',
    },
    estimateGasFromPlugins: function (plugins, chainId) {
        // Gas notes:
        // 1st call 32000
        // every next call 27000
        var gas = BigNumber.from(32000);
        if (plugins.length > 1) {
            gas = gas.add(BigNumber.from(plugins.length - 1).mul(BigNumber.from(27000)));
        }
        if (chainId === '42161') {
            gas = gas.mul(BigNumber.from(13));
        }
        return gas.toString();
    },
    beforeSimulate: function (_a) {
        var params = _a.params, provider = _a.provider, chainId = _a.chainId;
        return __awaiter(void 0, void 0, void 0, function () {
            var tokenRecipients, tokenAmount, amountToSend, contractAddress, tokenAddress, contract;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!params)
                            return [2 /*return*/];
                        tokenRecipients = params[3].value;
                        tokenAmount = params[2].value;
                        console.log({ params: params, tokenRecipients: tokenRecipients, tokenAmount: tokenAmount });
                        if (!tokenAmount)
                            return [2 /*return*/];
                        if (!tokenRecipients)
                            return [2 /*return*/];
                        if (!('length' in tokenRecipients))
                            return [2 /*return*/];
                        amountToSend = BigNumber.from(tokenAmount).mul(tokenRecipients.length);
                        contractAddress = kiroboMulticallSimulateContracts[chainId];
                        tokenAddress = params[0].value;
                        console.log({ tokenAddress: tokenAddress });
                        if (!tokenAddress)
                            return [2 /*return*/];
                        contract = new Contract(tokenAddress, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer);
                        return [4 /*yield*/, ((_b = provider === null || provider === void 0 ? void 0 : provider.signer) === null || _b === void 0 ? void 0 : _b.sendTransaction({
                                to: contractAddress,
                                value: '1' + '0'.repeat(3),
                            }))
                            //const res1 = await contract['transfer'](contractAddress, amountToSend.toString(), {})
                        ];
                    case 1:
                        _c.sent();
                        //const res1 = await contract['transfer'](contractAddress, amountToSend.toString(), {})
                        return [4 /*yield*/, contract['approve'](contractAddress, amountToSend.toString(), {})];
                    case 2:
                        //const res1 = await contract['transfer'](contractAddress, amountToSend.toString(), {})
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
});
